/** Standard motor benefits copy for quote PDF / email (aligned with agent underwriting). */

export const MOTOR_COVER_LABELS = {
  101: 'Comprehensive',
  106: 'Third Party Only',
  105: 'TP, Fire & Theft',
};

export const MOTOR_COMP_INCLUDED_BENEFITS = [
  { label: 'Towing', limit: 'Free Limit KSH 30,000' },
  { label: 'Entertainment', limit: 'Free Standard Limit KSH 30,000' },
  { label: 'Windscreen', limit: 'Free Standard Limit KSH 30,000' },
  { label: 'Damages Repair', limit: 'Free Limit KSH 30,000' },
];

export const MOTOR_COMP_OTHER_BENEFITS = [
  { label: 'Legal Defence', limit: 'Free limit KSH 10,000' },
  { label: 'Medical Expenses', limit: 'Free limit KSH 30,000' },
  { label: 'Passengers Liability', limit: 'Any Person KSH 3M / Any Event KES 20M' },
  { label: 'Third Party Person Liability', limit: 'Any Person KSH 3M / Any Event KSH 5M' },
  { label: 'Third Party Property Damage', limit: 'Free limit KSH 5,000,000' },
];

export const MOTOR_TPO_BENEFITS = [
  { label: 'Third Party Person Liability', limit: 'Any Person KSH 3M / Any Event KSH 5M' },
  { label: 'Third Party Property Damage', limit: 'Free limit KSH 5,000,000' },
  { label: 'Passengers Liability', limit: 'Any Person KSH 3M / Any Event KES 20M' },
];
